import React from "react";
import { useNavigate } from "react-router-dom";
import heroPolyLight from "../../assets/waves/heroPolyLight.svg";
import heroPolyDark from "../../assets/waves/heroPolyDark.svg";
import { ChevronRight } from "lucide-react";

const Hero = (props) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col justify-center items-center px-4 md:px-[10%] md:flex-row md:justify-between min-h-screen pt-28 pb-2 md:pt-[60px] md:pb-0 bg-no-repeat bg-center bg-cover overflow-x-hidden"
    >
      {/* Left Side: Content */}
      <div className="text-center md:text-left flex flex-col items-center md:items-start max-w-xl z-10 mb-12 md:mb-0">
        <div className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold text-blue-600 bg-white/50 backdrop-blur-sm rounded-full dark:text-blue-300 border border-blue-200 dark:border-white/20">
          The Ultimate Placement Guide
        </div>

        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-black dark:text-white leading-tight mb-6 drop-shadow-sm">
          Master DSA<br />
          <span className="text-blue-600 dark:text-blue-400">Crack the OA</span><br/>
          <span className="text-4xl md:text-5xl text-blue-600 dark:text-blue-400 block mt-2">FOR FREE</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-8 leading-relaxed font-medium px-2 md:px-0">
          Your comprehensive roadmap to engineering placements. Access curated sheets, archives, and daily challenges.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto px-2 md:px-0">
          <button 
            onClick={() => navigate('/learn')}
            className="px-8 py-3.5 text-base font-bold text-white bg-black dark:bg-white dark:text-black rounded-full hover:bg-blue dark:hover:bg-blue hover:text-white dark:hover:text-white transition-all duration-300 shadow-lg hover:shadow-blue-500/25 transform hover:-translate-y-1 flex items-center justify-center gap-2"
          >
            Start Preparing
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      {/* Right Side: 3D Status Card */}
      <div className="relative flex justify-center items-center perspective-1000 w-full md:w-auto z-10">
        <div className="relative w-full max-w-[90vw] md:max-w-xl bg-white/90 dark:bg-[#0651c3] backdrop-blur-xl rounded-3xl shadow-2xl dark:shadow-blue-900/20 border border-white/50 dark:border-white/10 p-6 md:p-8 transform rotate-0 md:rotate-3 hover:rotate-0 transition-all duration-500 ease-out">
          
          <div className="flex items-center gap-3 mb-6 border-b border-gray-300 dark:border-white pb-6">
            <div className="w-3 h-3 md:w-4 md:h-4 rounded-full bg-red-500 shadow-sm"></div>
            <div className="w-3 h-3 md:w-4 md:h-4 rounded-full bg-yellow-400 shadow-sm"></div>
            <div className="w-3 h-3 md:w-4 md:h-4 rounded-full bg-green-500 shadow-sm"></div>
            <div className="ml-auto text-xs md:text-sm font-mono text-gray-500 dark:text-white">Status: Placed</div>
          </div>
          
          <div className="space-y-4 md:space-y-6">
            
            <div className="flex items-center p-4 md:p-5 rounded-2xl bg-gray-100 border border-gray dark:border-white/5 transition-colors dark:bg-blue">
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-blue-50 dark:bg-white flex items-center justify-center text-blue-600 dark:text-blue-400 font-bold shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 md:w-8 md:h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
              </div>
              <div className="ml-4 md:ml-5">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">CM Sheet</h3>
                <p className="text-sm md:text-base text-gray-500 dark:text-white">450+ Curated Problems</p>
              </div>
            </div>

            <div className="flex items-center p-4 md:p-5 rounded-2xl bg-gray-100  border border-gray dark:border-white/5 transition-colors dark:bg-blue">
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl dark:bg-white flex items-center justify-center text-black dark:text-black font-bold shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 md:w-8 md:h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
              </div>
              <div className="ml-4 md:ml-5">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">OA Archive</h3>
                <p className="text-sm md:text-base text-gray-500 dark:text-white">Real Company Questions</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;